import { useAuthContext } from '@/modules/Auth/Auth.context';
import { PropsWithChildren, ReactNode, useEffect } from 'react';

import { NO_PERMISSIONS_MESSAGE, UserPermission } from './Permissions.constants';
import { usePermissions } from './Permissions.hooks';

type Props = PropsWithChildren<{
  permissions: UserPermission[];
  conditions?: { permissions: UserPermission[]; condition: () => boolean }[];
  fallback?: ReactNode;
}>;
export const IfPermitted = ({ permissions, conditions, fallback, children }: Props) => {
  const { authenticationStatus } = useAuthContext();
  const { hasPermission } = usePermissions();

  const hasDefaultAccess = hasPermission(permissions);
  const hasConditionalAccess = conditions?.some(({ permissions, condition }) => hasPermission(permissions) && condition()) || false;
  const hasAccess = hasDefaultAccess || hasConditionalAccess;

  useEffect(() => {
    if (authenticationStatus === 'AUTHENTICATED' && !hasAccess && fallback === undefined) {
      throw new Error(NO_PERMISSIONS_MESSAGE);
    }
  }, [fallback, authenticationStatus, hasAccess]);

  return <>{hasAccess ? children : fallback}</>;
};
